import React from "react";
import { Answer } from "../../../Question";

interface AnswerReferenceProps {
    reference: any;
}

export default function AnswerReference({ reference }: AnswerReferenceProps) {
    return <Answer style={{ color: "#10A97A" }} answer={reference} />;
}
